import React, { ReactNode } from 'react';
import { actionBarMinWidthWrapper } from 'src/components/common/common';
import { useSearchSectionHeight } from './SearchSectionContext';

interface SearchSectionFormProps {
	children: ReactNode;
	expandSearch?: () => ReactNode;
	buttonText?: string; // 버튼 텍스트를 커스터마이징할 수 있는 prop
}

export const SearchSectionForm: React.FC<SearchSectionFormProps> = ({ children, expandSearch, buttonText = '상세검색' }) => {
	const { isExpanded, setIsExpanded, contentRef, contentHeight } = useSearchSectionHeight(expandSearch);

	return (
    <div className={`w-full flex items-start px-[12px] gap-[6px]`}>
		<div className={`w-full flex flex-col transition-all duration-500 `}>
		<div className={`w-full flex flex-wrap content-start items-center justify-between gap-[8px] border-gray-300 px-[12px] py-[4px] mb-[4px] border overflow-y-auto ${actionBarMinWidthWrapper}`}>
			<div className="flex flex-wrap content-start items-center gap-[8px]">
				{children}
			</div>
			{expandSearch &&
					<button 
						onClick={() => {
							setIsExpanded(!isExpanded);
						}} 
						className={`flex-shrink-0 bg-white hover:bg-gray-100 border border-gray-300 text-gray-800 font-semibold  px-4 rounded shadow h-[30px]`}
					>
						{buttonText}
					</button>
				}
			</div>
			{expandSearch &&
				<div 
					className="transition-[height] duration-500 ease-in-out overflow-hidden"
					style={{ height: isExpanded ? `${contentHeight}px` : '0px' }}
				>
					<div 
						ref={contentRef}
						className={`
							w-full flex gap-x-[8px] flex-wrap content-start items-center 
							border-gray-300 ${actionBarMinWidthWrapper} border py-[4px]
							transition-opacity duration-300 ease-in-out
							${isExpanded ? 'opacity-100' : 'opacity-0'}
						`}
					>
						{expandSearch()}
					</div>
				</div>
			}
			</div>
    </div>
	);
};